/**
 * TCR — Liaison UI des favoris.
 *
 * Séparé de wishlist.js (le moteur) : ici uniquement le DOM.
 *  - délégation d'événement sur [data-wishlist-toggle] (marche pour les cartes
 *    injectées après coup par la Section Rendering API des facettes)
 *  - synchronisation de l'état visuel de tous les boutons à chaque changement
 *  - badge compteur du header
 *  - push Klaviyo (les flows back-in-stock / price drop se brancheront dessus)
 */
(function () {
  'use strict';

  var cfg = window.tcrWishlistConfig || {};

  function t(key, fallback) {
    return (cfg.strings && cfg.strings[key]) || fallback;
  }

  // ─── Klaviyo ───────────────────────────────────────────────────────────────
  // Le script Klaviyo est chargé par l'app (app embed), pas par le thème : il
  // peut ne pas être prêt. `_learnq` est une file d'attente, pousser dedans
  // avant chargement est sûr — mais on garde le try/catch au cas où un
  // bloqueur de pub aurait neutralisé l'objet.

  function trackKlaviyo(eventName, btn) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push([
        'track',
        eventName,
        {
          ProductID: btn.getAttribute('data-product-id'),
          VariantID: btn.getAttribute('data-variant-id'),
          Handle: btn.getAttribute('data-handle'),
          Title: btn.getAttribute('data-title') || '',
          URL: window.location.origin + '/products/' + btn.getAttribute('data-handle'),
        },
      ]);
    } catch (e) {}
  }

  // ─── Rendu de l'état ───────────────────────────────────────────────────────

  function paintButton(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      active ? t('remove', 'Retirer des favoris') : t('add', 'Ajouter aux favoris')
    );
    var label = btn.querySelector('.wishlist-btn__label');
    if (label) {
      label.textContent = active
        ? t('remove', 'Retirer des favoris')
        : t('add', 'Ajouter aux favoris');
    }
    // Première résolution faite : on peut afficher le bouton.
    btn.removeAttribute('data-wishlist-pending');
  }

  function paintAll() {
    if (!window.TCRWishlist) return;
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var v = btns[i].getAttribute('data-variant-id');
      paintButton(btns[i], window.TCRWishlist.has(v));
    }
    paintBadge();
  }

  function paintBadge() {
    var n = window.TCRWishlist ? window.TCRWishlist.count() : 0;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n > 99 ? '99+' : String(n);
      badges[i].hidden = n === 0;
      badges[i].closest('[data-wishlist-link]')?.classList.toggle('has-items', n > 0);
    }
  }

  // ─── Interaction ───────────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wishlist-toggle]');
    if (!btn || !window.TCRWishlist) return;

    // Les cartes produit sont enveloppées dans un <a> : sans ça, un clic sur le
    // coeur navigue vers la fiche produit.
    e.preventDefault();
    e.stopPropagation();

    if (btn.hasAttribute('data-wishlist-busy')) return;
    btn.setAttribute('data-wishlist-busy', '');

    var item = {
      productId: btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-variant-id'),
      handle: btn.getAttribute('data-handle'),
      quantity: 1,
    };

    // Retour optimiste : le coeur bascule immédiatement, on corrige si l'appel
    // échoue. Sur mobile 4G l'aller-retour proxy se voit sinon nettement.
    var optimistic = !window.TCRWishlist.has(item.variantId);
    paintButton(btn, optimistic);

    window.TCRWishlist.toggle(item)
      .then(function (added) {
        trackKlaviyo(added ? 'Added to Wishlist' : 'Removed from Wishlist', btn);
        paintAll();
      })
      .catch(function () {
        paintButton(btn, !optimistic);
        paintBadge();
      })
      .then(function () {
        btn.removeAttribute('data-wishlist-busy');
      });
  });

  // Le moteur émet à chaque mutation ET à la fin de l'amorçage.
  document.addEventListener('tcr:wishlist:change', paintAll);

  // Les facettes du thème réinjectent la grille produit via la Section
  // Rendering API : les nouveaux boutons arrivent sans état.
  document.addEventListener('shopify:section:load', paintAll);

  // FoxTheme n'utilise pas d'événements DOM mais son propre pubsub.
  // On s'y abonne dès qu'il est disponible (theme.js est chargé en defer,
  // l'ordre d'exécution n'est donc pas garanti).
  function bindFoxTheme() {
    if (!window.FoxTheme || !window.FoxTheme.pubsub) return false;
    var E = window.FoxTheme.pubsub.PUB_SUB_EVENTS || {};

    window.FoxTheme.pubsub.subscribe(E.facetUpdate || 'facet-update', paintAll);

    // Sur la PDP, le cœur doit suivre la variante réellement sélectionnée.
    window.FoxTheme.pubsub.subscribe(E.variantChange || 'variant-change', function (data) {
      var variant = data && (data.variant || (data.detail && data.detail.variant));
      if (!variant || !variant.id) return;
      var btns = document.querySelectorAll('[data-wishlist-pdp]');
      for (var i = 0; i < btns.length; i++) {
        btns[i].setAttribute('data-variant-id', 'gid://shopify/ProductVariant/' + variant.id);
      }
      paintAll();
    });
    return true;
  }

  if (!bindFoxTheme()) {
    // theme.js pas encore exécuté : on retente au chargement complet.
    window.addEventListener('load', bindFoxTheme);
  }

  // Filet principal : le scroll infini des collections injecte des cartes sans
  // émettre aucun de ces événements. Sans observateur, ces boutons restent en
  // `pending` et donc invisibles. Constaté en conditions réelles sur
  // /collections/hay : 50 boutons sur 50 non peints après défilement.
  if (typeof MutationObserver !== 'undefined') {
    var scheduled = false;
    var observer = new MutationObserver(function (mutations) {
      if (scheduled) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            n.hasAttribute('data-wishlist-toggle') ||
            n.querySelector('[data-wishlist-toggle]')
          ) {
            // Regroupe les injections successives en un seul repaint.
            scheduled = true;
            requestAnimationFrame(function () {
              scheduled = false;
              paintAll();
            });
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }
})();
